import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * usePreventBack()
 * Prevents user from navigating back using the browser back button.
 *
 * Usage:
 *   usePreventBack();
 */
export function usePreventBack() {
  const navigate = useNavigate();

  useEffect(() => {
    // Push a new state into history
    globalThis.history.pushState(null, '', globalThis.location.href);

    const handlePopState = () => {
      // Push them forward again to prevent back
      globalThis.history.pushState(null, '', globalThis.location.href);
      // Optional: reload or redirect if you prefer
      navigate(0);
      // navigate("/home", { replace: true });
    };

    globalThis.addEventListener('popstate', handlePopState);
    return () => globalThis.removeEventListener('popstate', handlePopState);
  }, [navigate]);
}
